<script>
// import appConfig from '@src/app.config'
import {
  reportListMethod,
  collegeComputed,
  collegeListMethod,
  authComputed,
} from '@state/helpers'
import { ErrorWrapper } from '@utils/error-handler'
export default {
  data() {
    return {
      title: '',
      description: '',
      error: null,
      reportRequest: false,
      isChangeError: false,
      isSuccess: false,
      successMessage: null,
      prevent: null,
      isReportError: false,
      reportError: false,
      reportSuccess: '',
      isLoading: false,
      collegelist: [],
      collegeId: null,
    }
  },
  computed: {
    ...authComputed,
    ...collegeComputed,
  },
  mounted() {
    this.getColleges()
    if (this.role === 'college') {
      this.collegeId = this.profileData.college_id
    } else {
      this.collegeId = 'All'
    }
  },
  methods: {
    ...reportListMethod,
    ...collegeListMethod,

    getColleges() {
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchCollegeList({ filter })
        .then((college) => {
          var listitems = []
          listitems.push({ value: 'All', text: 'All' })
          college.docs.forEach((element) => {
            var ele = {}
            ele.text = element.name
            ele.value = element._id
            ele.platform_id = element.platform_id
            listitems.push(ele)
          })
          this.collegelist = listitems
        })
        .catch((_error) => {})
    },

    requestReport() {
      this.isLoading = true
      const report = {
        title: this.title,
        description: this.description,
        college_id: this.collegeId,
      }
      this.addReportRequest({ report })
        .then((reportrequest) => {
          this.isLoading = false
          this.title = ''
          this.description = ''
          this.reportSuccess = 'Report Request Submiited Successfully'
          this.isSuccess = true
          window.location.reload()
        })
        .catch((error) => {
          this.isLoading = false
          this.title = ''
          this.description = ''
          this.isLoading = false
          var getError = new ErrorWrapper(error)
          this.reportError = getError.message
          this.isReportError = true
        })
    },
    resetModal() {
      this.title = ''
      this.description = ''
      this.reportSuccess = ''
      this.isSuccess = false
      this.isReportError = false
      this.reportError = ''
    },
  },
}
</script>
<template>
  <b-modal
    id="my-modal1"
    title="To Request a new Report, add report title and description below:"
    :hide-footer="true"
    @hidden="resetModal"
  >
    <b-overlay :show="isLoading" :opacity="0.6" rounded="sm">
      <b-form @submit.prevent="requestReport"
        ><br />
        <b-alert
          v-model="isReportError"
          variant="danger"
          v-html="reportError"
        ></b-alert>
        <b-alert
          v-model="isSuccess"
          variant="success"
          v-html="reportSuccess"
        ></b-alert>
        <b-form-group label="Report Title" label-for="title">
          <b-form-input
            id="title"
            v-model="title"
            type="text"
            required
            placeholder="Add Report Title"
          ></b-form-input>
        </b-form-group>

        <b-form-group label="Report Description" label-for="description">
          <b-form-input
            id="description"
            v-model="description"
            type="text"
            required
            placeholder="Add Report Description"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          v-if="role === 'administrator'"
          label="Select College"
          label-for="input-1"
        >
          <b-form-select
            v-model="collegeId"
            :options="collegelist"
          ></b-form-select>
        </b-form-group>
        <b-form-group id="button-group" class="mt-2">
          <b-button type="submit" variant="primary" class="btn-block button"
            >Submit</b-button
          >
        </b-form-group>
      </b-form>
    </b-overlay>
  </b-modal>
</template>
<style>
.button {
  width: 100px;
  background-color: skyblue;
}
.modal-backdrop {
  opacity: 0.5;
}
</style>
